// extracted by mini-css-extract-plugin
export default {"container":"BioInformation_container__IeBBr","bold-title":"BioInformation_bold-title__lGfbW","head-line":"BioInformation_head-line__2kwq9","body":"BioInformation_body__-HELy"};